/* eslint-disable @typescript-eslint/no-unsafe-return */
import React from "react";

type ActionCheck = (x0: React.KeyboardEvent<HTMLElement>) => boolean;

interface KeyboardActionMatcher<Actions> {
    type: Actions;
    check: (x0: React.KeyboardEvent<HTMLElement>) => boolean;
}

export class KeyboardActionExctracterBuilder<T> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private readonly actionMatchers: Array<KeyboardActionMatcher<any>>;

    public constructor(actionMatchers: Array<KeyboardActionMatcher<T>> = []) {
        this.actionMatchers = actionMatchers;
    }

    public add(type: T, check: ActionCheck): KeyboardActionExctracterBuilder<T> {
        return new KeyboardActionExctracterBuilder(this.actionMatchers.concat({ type: type, check: check }));
    }

    public build<P = T>(defaultAction: P): (x0: React.KeyboardEvent<HTMLElement>) => T {
        return event => {
            const action = this.actionMatchers.find(x => x.check(event));
            return (action && action.type) || defaultAction;
        };
    }
}
